import useSWR from "swr";

import creditCardData from "@/api/creditCardDataDic";

export interface CreditCardItemType {
  annual_fee: number;
  balance_transfer_offer: boolean;
  bank: number;
  bonus: string;
  categories: number[];
  detail: string;
  first_year_annual_fee: number;
  id: number;
  img: string;
  limited_time_offer: boolean;
  link: string;
  money: number;
  name: string;
  intro_offer: string;
  promotion: null | string;
  purchase_apr: boolean;
  quidget_card_id: number;
  rate_fee_link: string;
  spending_requirement: number;
  summary: string;
  tag_line: string;
  uri: string;
  benefit: {
    bold: string;
    value: string;
  }[];
  credit_requirement: {
    category: string;
    score: string;
  };
}

const url = "https://apis.awardtoolapi.com/credit_card_all";

export interface ApiCreditCardsResponse {
  banks: { id: number; name: string }[];
  categories: { id: number; is_benefit: boolean; name: string }[];
  cards: CreditCardItemType[];
}

export const getCreditCards = async () => {
  const res = await fetch(url);

  const json = await res.json();

  return json.data.data as ApiCreditCardsResponse;
};

export const useGetCreditCards = () => {
  return useSWR(url, async () => {
    // const res = await getCreditCards();

    // return res;

    return creditCardData;
  });
};

export const useGetCreditCardById = (id: number) => {
  return useSWR(url, async () => {
    return creditCardData.cards.find((item) => item.id === id);
  });
};
